<template>
  <div class="nameList">
    <div class="search">
      <el-date-picker
        v-model="queryParams.pushDate"
        type="date"
        placeholder="选择日期"
        @change="selfGetTitleList"
        value-format="yyyy-MM-dd"
        :disabled="typeval"
      ></el-date-picker>
      <div>
        <el-input
          v-model="queryParams.userName"
          clearable
          placeholder="搜索员工姓名"
          @change="selfGetTitleList"
          prefix-icon="el-icon-search"
        ></el-input>
      </div>
      <div>
        <el-button @click="Export" :disabled="tableData.length < 1">导出</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        v-loading="tableLoading"
        ref="singleTable"
        :data="tableData"
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column property="userName" label="员工姓名" min-width="30%"></el-table-column>
        <el-table-column property="userId" label="userId" min-width="30%"></el-table-column>
        <el-table-column property="hireDate" label="入职时间" min-width="30%"></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import {
  QueryEmployesOfRule,
  QueryEmployesOfLog,
  QueryEmployesOfLogCsv,
  QueryEmployesOfRuleCsv,
} from '../../../../api/pointsRule';
export default {
  name: 'Article',
  components: {},
  props: {
    // 请求参数
    parameter: {
      type: Object,
      default: () => ({}),
    },
    // 展示的类型
    typeval: {
      type: Boolean,
      default: false,
    },
    // 选中的名单
    name: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      tableLoading: false,
      queryParams: {
        ruleId: '', // 规则ID
        userName: '', // 用户名称
        pushDate: new Date(), // 推送日期
      },
      tableData: [],
    };
  },
  watch: {
    parameter: {
      handler(parameter) {
        if (parameter.pushDate && this.typeval) {
          this.queryParams.pushDate = parameter.pushDate;
          this.getTitleList();
        }
      },
      // 深度观察监听
      immediate: true,
      deep: true,
    },
  },
  created() {},
  mounted() {},
  methods: {
    getTitleList() {
      this.tableLoading = true;
      this.tableData = [];
      if (this.typeval) {
        const params = {
          ruleLogId: this.parameter.ruleId,
        };
        // 查询实际名单
        QueryEmployesOfLog(params)
          .then((res) => {
            const data = res?.ruleList;
            this.tableData = data;
            this.tableLoading = false;
          })
          .catch((res) => {
            console.log(res);
            this.tableLoading = false;
          });
      } else {
        // 查询预演名单
        const params = {
          ruleId: this.parameter.ruleId,
          pushDate: `${this.parameter.pushDate} 00:00:00`,
        };
        QueryEmployesOfRule(params)
          .then((res) => {
            const data = res?.employesOfRuleList;
            this.tableData = data;
            this.tableLoading = false;
          })
          .catch((res) => {
            console.log(res);
            this.tableLoading = false;
          });
      }
    },
    selfGetTitleList() {
      const that = this;
      that.tableLoading = true;
      that.tableData = [];
      if (that.typeval) {
        // 查询实际
        const parma = {
          ruleLogId: that.parameter.ruleId,
          userName: that.queryParams.userName, // 用户名称
        };
        QueryEmployesOfLog(parma)
          .then((res) => {
            const data = res?.ruleList;
            that.tableData = data;
            that.tableLoading = false;
          })
          .catch((res) => {
            console.log(res);
            that.tableLoading = false;
          });
      } else {
        // 查询预演
        const parma = {
          ruleId: that.parameter.ruleId, // 规则ID
          userName: that.queryParams.userName, // 用户名称
          pushDate: `${that.queryParams.pushDate} 00:00:00`,
        };
        QueryEmployesOfRule(parma)
          .then((res) => {
            const data = res?.employesOfRuleList;
            that.tableData = data;
            that.tableLoading = false;
          })
          .catch((res) => {
            console.log(res);
            that.tableLoading = false;
          });
      }
    },
    // 导出事件
    Export() {
      if (this.typeval) {
        // 导出实际
        const params = {
          ruleLogId: this.parameter.ruleId,
          userName: this.queryParams.userName, // 用户名称
        };
        QueryEmployesOfLogCsv(params).then((res) => {
          if (res.data) {
            const blob = new Blob([res.data]);
            const elink = document.createElement('a');
            elink.download = '推送日志名单详情.csv';
            elink.href = URL.createObjectURL(blob);
            elink.click();
          }
        });
      } else {
        // 导出预演
        const params = {
          ruleId: this.parameter.ruleId,
          pushDate: `${this.queryParams.pushDate} 00:00:00`,
          userName: this.queryParams.userName, // 用户名称
        };
        QueryEmployesOfRuleCsv(params).then((res) => {
          if (res.data) {
            const blob = new Blob([res.data]);
            const elink = document.createElement('a');
            elink.download = `${`${this.name}推送名单`}.csv`;
            elink.href = URL.createObjectURL(blob);
            elink.click();
          }
        });
      }
    },
    // 重置参数
    resetParameters() {
      this.queryParams = {
        ruleId: '', // 规则ID
        userName: '', // 用户名称
        pushDate: new Date(), // 推送日期
      };
      this.tableData = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.nameList {
  width: 100%;
  height: 100%;
  padding: 0px 0px 30px 5px;
  .search {
    display: flex;
    justify-content: start;
    height: 56px;
    line-height: 56px;
    margin-left: 30px;
    .el-date-editor {
      width: 200px;
      margin-right: 15px;
    }
    .el-button {
      padding: 10px 20px;
      margin-left: 15px;
    }
  }
  .table {
    margin-left: 30px;
  }
  ::v-deep .el-input__inner {
    height: 36px;
  }
  ::v-deep .el-table__body-wrapper {
    height: 300px;
    max-height: 500px;
    overflow-y: auto;
  }
}
</style>
